import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Title } from 'components/layout'
import styles from './tasks-award-leader-note.styl'

export default class TasksAwardLeaderNote extends Component {
  static propTypes = {
    note: PropTypes.string,
    personalReflection: PropTypes.string,
    fromLeader: PropTypes.bool
  }

  render() {
    const { note, personalReflection, fromLeader } = this.props

    return (
      <div>
        <Title
          h2
          intlKey={
            fromLeader ? 'moduleTitle.note_from_al' : 'moduleTitle.note_for_al'
          }
        >
          {fromLeader ? 'Note from Award leader' : 'Note for Award leader'}
        </Title>
        {note ? <p className={styles.note}>{note}</p> : <FormattedMessage id="label.no_note" defaultMessage="No note" />}

        {personalReflection && <div className={styles.noteTitle}>
         <FormattedMessage
             id="label.participant_personal_reflection"
                defaultMessage="Participant personal reflection"
            /><br />
            <p className={styles.note}>{personalReflection}</p></div>}
      </div>
    )
  }
}
